import {translations} from 'presentation/translations-new';
/**
 * Utils for currency
 *
 * @example
 * const currency = currencyHandle(100);
 * currency.isGreaterThan(currencyHandle(50).getValue()); // true
 * const currency2 = currencyHandle().fromString('100,00');
 * currency2.isGreaterThan(currencyHandle(50).getValue()); // true
 * const currency3 = currencyHandle().fromString('00,02');
 * currency3.isGreaterThan(currencyHandle(2).getValue()); // false
 */

const {negativeCurrencyValue} = translations['pt-br'].others.currency.validations;
const {requiredField} = translations['pt-br'].commons;

export function currencyHandle(value?: number) {
	if (value && value < 0) {
		throw new Error(negativeCurrencyValue);
	}
	return {
		getValue() {
			if (!value) {
				throw new Error(requiredField);
			}
			return value;
		},
		isGreaterThan(minValue: number) {
			return value && value > minValue;
		},
		fromString(strValue: string) {
			return currencyHandle(Number(strValue.replace(/\D/g, '')) / 100);
		},
	};
}
